import React from 'react';
import { useDeepCompareEffect } from 'react-use';
import { useDispatch } from 'react-redux';
import { useTranslate, useLocalizedDataSelector } from '@hooks';
import { fetchCategoryGroups } from '@actions';
import { toNumberArray } from '@dotone/react-ui-core/utils';
import { FilterBlock } from '@dotone/react-ui-core';

const CategoryGroupFilterBlock = ({ ids = [], ...otherProps }) => {
  const { locale, t } = useTranslate('affiliate', 'model');
  const dispatch = useDispatch();
  const categoryGroups = useLocalizedDataSelector(({ categoryGroupList }) => categoryGroupList);

  useDeepCompareEffect(() => {
    if (ids && !categoryGroups.length) {
      dispatch(fetchCategoryGroups(locale));
    }
  }, [dispatch, locale, ids, categoryGroups.length]);

  const filter = (items, categoryGroupIds = []) => {
    return items.filter((item) => toNumberArray(categoryGroupIds).indexOf(item.id) > -1);
  };

  return (
    <FilterBlock label={t('categoryGroups')} items={filter(categoryGroups, ids)} {...otherProps} />
  );
};

export default React.memo(CategoryGroupFilterBlock);
